import { Component } from '@angular/core';
import {ToastComponent} from "../toast.component";
import {TranslatePipe} from "@ngx-translate/core";

@Component({
  selector: 'app-global-error-toast',
  imports: [
    TranslatePipe
  ],
  templateUrl: './global-error-toast.component.html',
  styleUrl: './global-error-toast.component.scss'
})
export class GlobalErrorToastComponent extends ToastComponent {

  override doClose(): any {
    this.close.emit( this.outputPredicate()() )
  }

}
